import React, { Component } from 'react'
import { observer } from 'mobx-react'

@observer(['globals'])
export default class Profile extends Component {

  constructor(props, context) {
    super(props, context);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();

    this.props.onClick(e);
  }

  render() {
    return (
      <a href="javascript:;" className="user-profile dropdown-toggle" data-toggle="dropdown" aria-expanded="false" onClick={this.handleClick}>
        { this.props.globals.loggedInUser.firstName } { this.props.globals.loggedInUser.lastName }&nbsp;
        <span className=" fa fa-angle-down"></span>
      </a>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/profile.js